import { Fragment } from 'react';
import './index.css';
function IniPage() {
    return <Fragment >
        <div className='content-hotjar'>
            <img className="hotjar" src="assets/img/hotjar/hotjar.jpg" alt="" />
        </div>
    </Fragment>
  
}

export default IniPage;
